import { render, staticRenderFns } from "./PrintableComponent.vue?vue&type=template&id=5b491523"
import script from "./PrintableComponent.vue?vue&type=script&lang=js"
export * from "./PrintableComponent.vue?vue&type=script&lang=js"
import style0 from "./PrintableComponent.vue?vue&type=style&index=0&id=5b491523&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports